import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";

export default function EreciptPopup() {
	const {
		config,
		cart,
		updateOrderFromCart,
		checkout,
		setEreciptQrPopup,
		setEreciptPopup,
	} = useContext(AppContext);

	const isEditing = () => {
		let res = false;
		if (cart.order_id) res = true;
		return res;
	};

	return (
		<div className="erecipt">
			<div className="container">
				<div className="header">
					<div className="title">Come vuoi lo scontrino?</div>
				</div>
				<div className="content">
					{/* niente scelta "via email": con il QR (erecipt 2) il link lo invia l'API all'email del cliente dell'ordine */}
					<div className="receipt-qr-print">
						{!config.virtual_printer_id && (
							<div className="title">Vuoi stampare lo scontrino?</div>
						)}
						<div>
							<button
								onClick={() => {
									setEreciptPopup(false);
									setEreciptQrPopup(true);
									if (isEditing()) {
										updateOrderFromCart(
											false,
											true,
											config.virtual_printer_id
												? false
												: config.prebill_on_checkout == 1
										);
									} else {
										checkout(
											false,
											false,
											true,
											false,
											config.virtual_printer_id
												? false
												: config.prebill_on_checkout == 1,
											{ erecipt: 2 }
										);
									}
								}}
							>
								Genera QRcode
							</button>
							<button
								onClick={() => {
									setEreciptPopup(false);
									if (isEditing()) {
										updateOrderFromCart(
											false,
											true,
											config.virtual_printer_id
												? true
												: config.prebill_on_checkout == 1
										);
									} else {
										checkout(
											false,
											false,
											true,
											false,
											config.virtual_printer_id
												? true
												: config.prebill_on_checkout == 1
										);
									}
								}}
							>
								{config.virtual_printer_id ? "Stampa QrCode" : "Stampa"}
							</button>
							<button className="back-button" onClick={() => setEreciptPopup(false)}>
								Indietro
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
